import { AutogenModelFreightMatchingProfile, AutogenRowFreightMatchingProfile } from "./autogen/AutogenModelFreightMatchingProfile";

export class ModelFreightMatchingProfile extends AutogenModelFreightMatchingProfile<RowFreightMatchingProfile> {
	constructor() {
		super(RowFreightMatchingProfile);
	}
}

export class RowFreightMatchingProfile extends AutogenRowFreightMatchingProfile {
}